import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function HeaderHero({ bgImage, logo, overlayMs = 900, className = "" }) {
    const [showOverlay, setShowOverlay] = useState(true);

    useEffect(() => {
        const t = setTimeout(() => setShowOverlay(false), overlayMs);
        return () => clearTimeout(t);
    }, [overlayMs]);

    return (
        <div className={className} style={{
            width: "100%",
            height: "100%",
            position: "relative",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#fff",
            flexShrink: 0,
        }}>
            {/* OVERLAY ROSSO FISSO (sotto tutto) */}
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 1,
                    background: "linear-gradient(90deg, #99191b 0%, #e3764c 100%)",
                }}
            />

            {/* IMMAGINE CHE RUOTA SOPRA IL ROSSO */}
            <motion.div
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    zIndex: 2,
                }}
                initial={{
                    opacity: 0.4,
                    rotate: 30,
                    scale: 1.8
                }}
                animate={{
                    opacity: 1,
                    rotate: 0,
                    scale: 1
                }}
                transition={{
                    duration: 1.8,
                    ease: "easeOut"
                }}
            >
                <img
                    src={bgImage}
                    alt=""
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                />
            </motion.div>

            {/* LOGO */}
            <img
                src={logo}
                alt="Logo"
                style={{
                    position: "relative",
                    zIndex: 4,
                    maxWidth: "20%",
                    height: "auto",
                }}
            />

            {/* OVERLAY CHE SCOMPARE */}
            <AnimatePresence>
                {showOverlay && (
                    <motion.div
                        initial={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 1 }}
                        style={{
                            position: "absolute",
                            inset: 0,
                            zIndex: 3,
                            background: "linear-gradient(90deg, #99191b 0%, #e3764c 100%)",
                        }}
                    />
                )}
            </AnimatePresence>
        </div>
    );
}
